import { CurrencyFormatter } from '../../../../../utilities';
import { BasicSiteMergeData, ContactMergeData, PurchaseOrderDeliveryAddressMergeData, PurchaseOrderLineMergeData, PurchaseOrderLinesMergeData, PurchaseOrderSupplierMergeData } from '../../data';
import { PurchaseOrderMergeDataSet } from '../../datasets';
import { FakeCompanyMergeData } from '../data';
import { PurchaseOrderStatus, TaxInclusiveOption } from '../../../../../entities';
import { DateTime } from 'luxon';

export class FakePurchaseOrderMergeDataset extends PurchaseOrderMergeDataSet {
    constructor(baseUrl: string = '') {
        super();

        const poDate = DateTime.local().toFormat('dd/MM/yyyy');

        this.purchaseOrder = {
            poNumber: 'PO0000001',
            poDate,
            comment: 'Sed dapibus, erat nec dignissim facilisis, velit ipsum lobortis orci, sed tincidunt tortor est ut sem. Etiam posuere aliquam enim id hendrerit.',
            status: PurchaseOrderStatus.Draft,
            createdBy: 'Finance User',
            createdAt: poDate,
            chargeable: 'Yes',
            taxRate: '10',
            taxInclusiveOption: TaxInclusiveOption.Inclusive,
            subTotal: CurrencyFormatter.formatCurrency(200, 2),
            total: CurrencyFormatter.formatCurrency(220, 2),
            tax: CurrencyFormatter.formatCurrency(20, 2),
            updatedAt: poDate,
            job: 'J1000'

        };

        this.purchaseOrderCompany = new FakeCompanyMergeData(baseUrl);
        this.purchaseOrderSupplier = {
            name: 'Good Supplier',
            phone: '02 8002 9590',
            email: 'supplier@email.com',
            street1: '1 Wentworth St',
            street2: '',
            suburb: 'Parramatta',
            state: 'NSW',
            country: 'Australia',
            postcode: '2150',
            contactName: 'Contact Name',
            markupPercentage: '10',
        } as PurchaseOrderSupplierMergeData;

        this.purchaseOrderSupplierContact = {
            name: 'Contact Name',
            phone: '02 8002 9590',
            mobile: '02 8002 9590',
            email: 'supplier@email.com',
        } as ContactMergeData;

        this.purchaseOrderSupplierAddress = {
            street: '1 Wentworth St',
            suburb: 'Parramatta',
            state: 'NSW',
            country: 'Australia',
            postcode: '2150',
            county: 'NSW',
            fullAddress: '1 Wentworth St, Parramatta, NSW, Australia, 2150',
        } as BasicSiteMergeData;

        this.purchaseOrderDeliveryAddress = {
            deliveryOptions: 'job',
            contactName: 'John Smith',
            contactPhone: '02 8002 9000',
            street1: '1 George St',
            street2: '',
            suburb: 'Parramatta',
            state: 'NSW',
            country: 'Australia',
            postcode: '2150',
        } as PurchaseOrderDeliveryAddressMergeData;

        this.purchaseOrderLine = {
            lines: this.createLines(),
        } as PurchaseOrderLinesMergeData;
    }

    private createLines(): PurchaseOrderLineMergeData[] {
        return [
            {
                name: 'Line 1',
                description: 'Description 1',
                quantity: '1',
                price: CurrencyFormatter.formatCurrency(100, 2),
                tax: CurrencyFormatter.formatCurrency(10, 2),
                subTotal: CurrencyFormatter.formatCurrency(100, 2),
                total: CurrencyFormatter.formatCurrency(110.00, 2),
                codeUoM: 'Unit',
                glCode: 'GL Code',
                taxRate: '10%',

            } as PurchaseOrderLineMergeData,
            {
                name: 'Line 2',
                description: 'Description 2',
                quantity: '2',
                price: CurrencyFormatter.formatCurrency(200, 2),
                tax: CurrencyFormatter.formatCurrency(20, 2),
                subTotal: CurrencyFormatter.formatCurrency(200, 2),
                total: CurrencyFormatter.formatCurrency(220, 2),
                codeUoM: 'Unit',
                glCode: 'GL Code',
                taxRate: '10%',
            } as PurchaseOrderLineMergeData,
        ];
    }

}